import { Box, Link } from 'braid-design-system';
import React from 'react';

import { SBusLogo } from '../../SBusLogo/SBusLogo';
import {
  createNavLinks,
  desktopHeaderActivatableNavButtonDataAttr,
  navLinkIds,
} from '../utils/generalUtils';

import * as styles from './NavButtons.css';

interface NavButtonInstanceProps {
  baseUrl: string;
}

export const HomeLogoButton = ({ baseUrl }: NavButtonInstanceProps) => (
  <Box className={styles.homeLogoButtonContainer}>
    <Link
      id={navLinkIds.homeLogo}
      href={createNavLinks(baseUrl).home}
      title="SEEK Business - Own your own business"
      className={styles.homeLogoButton}
      data={{ htag: navLinkIds.homeLogo }}
    >
      <SBusLogo theme="purple" width="163" height="32" />
    </Link>
  </Box>
);

export const BuyABusinessButton = ({ baseUrl }: NavButtonInstanceProps) => (
  <NavButton id={navLinkIds.home} href={createNavLinks(baseUrl).home}>
    Buy a business
  </NavButton>
);

export const SellABusinessButton = ({ baseUrl }: NavButtonInstanceProps) => (
  <NavButton
    id={navLinkIds.sellABusiness}
    href={createNavLinks(baseUrl).sellABusiness}
  >
    Sell a business
  </NavButton>
);

export const FranchiseButton = ({ baseUrl }: NavButtonInstanceProps) => (
  <NavButton id={navLinkIds.franchise} href={createNavLinks(baseUrl).franchise}>
    Franchise
  </NavButton>
);

export const FindBrokersButton = ({ baseUrl }: NavButtonInstanceProps) => (
  <NavButton
    id={navLinkIds.findBrokers}
    href={createNavLinks(baseUrl).findBrokers}
  >
    Find brokers
  </NavButton>
);

export const BlogButton = ({ baseUrl }: NavButtonInstanceProps) => (
  <NavButton
    id={navLinkIds.adviceAndTips}
    href={createNavLinks(baseUrl).adviceAndTips}
  >
    Advice & tips
  </NavButton>
);

// ============================================================================
// NavButton
// ============================================================================

interface NavButtonProps {
  id: string;
  href: string;
  children: string;
}

const NavButton = ({ id, href, children }: NavButtonProps) => (
  <Link
    id={id}
    href={href}
    className={styles.navButton}
    data={{
      [desktopHeaderActivatableNavButtonDataAttr]: '',
      htag: id,
    }}
  >
    <Box
      component="span"
      className={styles.navButtonText}
      data={{ text: children }}
    >
      {children}
    </Box>
  </Link>
);
